mutation UpdateGrantComplianceCheck($input: UpdateGrantComplianceCheckInput!) {
  updateGrantComplianceCheck(input: $input) {
    grantComplianceCheck {
      id
      status
      name
      createdAt
      updatedAt
    }
  }
}
